import React from 'react';
import { removeDomainName } from '../../../../utils/helper';
import './ColorOptions.scss';

const ColorOptions = React.memo(props => {
  const {
    showDitto,
    colorOptions,
    mouseInColor,
    mouseOutColor,
    dittoFound,
    gaqEventsPush,
    productUrl,
    productData,
    localeInfo,
  } = props;
  return (
    <div className="display-flex pull-right">
      <div className="colorOptions padding-l2">
        {colorOptions.map((colorObj, index) => {
          const colors = colorObj.color.split(',');
          const colortop = colors[0];
          let colorbottom = colors[1];
          if (typeof colorbottom === 'undefined') {
            colorbottom = colortop;
          }
          if (index < 6) {
            if (!dittoFound) {
              return (
                <a
                  key={index}
                  className="colorOptions_color_link"
                  href={
                    colorObj.product_url &&
                    removeDomainName(colorObj.product_url, '', localeInfo?.countryCode)
                  }
                  rel="noreferrer"
                  target="_blank"
                  title={`${colorObj.brand_name} ${colorObj.model_name}`}
                  onClick={() => {
                    if(localeInfo.countryCode !== 'sg') {
                      gaqEventsPush(
                        'Color',
                        'categoryColor',
                        `color=${colors}|name=${colorObj.model_name}`
                      );
                    }
                  }}
                  onMouseEnter={() => mouseInColor(index)}
                  onMouseLeave={() => mouseOutColor()}
                >
                  <span className="colorOptions_colorIcons">
                    <span
                      className="colorOptions_colorIcons_colorTop"
                      style={{ background: colortop }}
                    >
                      <span
                        className="colorOptions_colorIcons_colorBottom"
                        style={{ background: colorbottom }}
                      ></span>
                    </span>
                  </span>
                </a>
              );
            }
            if (!showDitto) {
              return (
                <a
                  key={index}
                  className="colorOptions_color_link"
                  href={
                    colorObj.product_url &&
                    removeDomainName(colorObj.product_url, '', localeInfo?.countryCode)
                  }
                  rel="noreferrer"
                  target="_blank"
                  title={`${colorObj.brand_name} ${colorObj.model_name}`}
                  onMouseEnter={() => mouseInColor(index)}
                  onMouseLeave={() => mouseOutColor()}
                >
                  <span className="colorOptions_colorIcons">
                    <span
                      className="colorOptions_colorIcons_colorTop"
                      style={{ background: colortop }}
                    >
                      <span
                        className="colorOptions_colorIcons_colorBottom"
                        style={{ background: colorbottom }}
                      ></span>
                    </span>
                  </span>
                </a>
              );
            }
          }
          return '';
        })}
      </div>
      {!showDitto && colorOptions.length > 6 && (
        <div className="fs12 lh-18">
          <a
            className="no-decoration text-color-grey"
            href={
              productUrl && removeDomainName(productData.product_url, '', localeInfo?.countryCode)
            }
            rel="noreferrer"
            target="_blank"
          >
            +{colorOptions.length - 6}
          </a>
        </div>
      )}
    </div>
  );
});

export default ColorOptions;
